import { getPackageExtractionPromise, getPackageVerificationInfoPromise } from "../../Rocky/rockyCtrl";
import { getChannelConfig, updateChannelConfig, updateChannelExtractionConfig } from "../../Rocky/projectCtrl";

class ChannelInfoDetail {
  constructor() {
    this.configInfo = new Map();
    this.pkgConfigInfo = new Map();
    this.pkgSetupInfo = new Map();
  }

  // config
  saveConfigInfo = (channelId, data) => {
    return this.configInfo.set(channelId, data);
  }

  getConfigInfo = (channelId) => {
    return this.configInfo.get(channelId);
  }

  getConfigInfoPromise = (channelId, isNew) => {
    return new Promise((resolve, reject) => {
      const config = this.getConfigInfo(channelId);
      if (config && !isNew) {
        resolve(config)
      } else {
        getChannelConfig(channelId).then(res => {
          if (res && res.config) {
            this.saveConfigInfo(channelId, res.config);
            resolve(res.config);
          } else {
            resolve({});
          }
        }, error => {
          resolve({});
        })
      }
    });
  }

  updateConfigConfigPromise = (channelId, updateConfigInfo) => {
    updateChannelConfig({ channelId, ...updateConfigInfo }).then(res => {
      const config = this.getConfigInfo(channelId);
      this.saveConfigInfo(channelId, { ...config, ...updateConfigInfo });
    })
  }

  updateConfigExtractionPromise = ({ channelId, extraction }) => {
    updateChannelExtractionConfig(channelId, extraction).then(res => {
      const config = this.getConfigInfo(channelId);
      this.saveConfigInfo(channelId, { ...config, extraction });
    })
  }

  getConfigExtractionInfoPromise = async (channelId) => {
    const config = await this.getConfigInfoPromise(channelId);
    return config.extraction || {};
  }


  getConfigConfigInfoPromise = async (channelId) => {
    const config = await this.getConfigInfoPromise(channelId);
    return config.config || {};
  }

  getCmd2TModePromise = async (channelId) => {
    const config = await this.getConfigConfigInfoPromise(channelId);
    return config.cmd_2t_mode ? config.cmd_2t_mode : false;
  }

  // pkg config
  savePkgConfigInfo = (pkgId, data) => {
    return this.pkgConfigInfo.set(pkgId, data);
  }

  getPkgConfigInfo = (pkgId) => {
    return this.pkgConfigInfo.get(pkgId);
  }

  getPkgConfigInfoPromise = (pkgId, isNew) => {
    return new Promise((resolve, reject) => {
      const config = this.getPkgConfigInfo(pkgId);
      if (config && !isNew) {
        resolve(config)
      } else {
        getPackageExtractionPromise(pkgId).then(res => {
          if (res) {
            this.savePkgConfigInfo(pkgId, res);
            resolve(res);
          } else {
            resolve({});
          }
        }, error => {
          resolve({});
        })
      }
    });
  }

  // pkgSetupInfo
  savePkgSetupInfo = (pkgInterfaceId, info) => {
    this.pkgSetupInfo.set(pkgInterfaceId, info);
  }

  getPkgSetupInfoPromise = async (pkgInterfaceId, isNew) => {
    return new Promise((resolve, reject) => {
      const config = this.getPkgSetupInfo(pkgInterfaceId);
      if (config && !isNew) {
        resolve(config)
      } else {
        getPackageVerificationInfoPromise(pkgInterfaceId).then(res => {
          if (res && res.content) {
            this.savePkgSetupInfo(pkgInterfaceId, res);
            resolve(res);
          } else {
            resolve({});
          }
        }, error => {
          resolve({});
        })
      }
    });
  }

  getPkgSetupInfo = (pkgInterfaceId) => {
    return this.pkgSetupInfo.get(pkgInterfaceId);
  }


  cleanAllInfo = () => {
    this.configInfo = new Map();
    this.pkgSetupInfo = new Map();
    this.pkgConfigInfo = new Map();
  }
}

const channelInfoDetail = new ChannelInfoDetail();

export default channelInfoDetail;